module.exports = __webpack_public_path__ + "static/media/hero.939dbe10.jpeg";